export var UnhandledRejection = 'UnhandledRejection';
export var NO_SUCH_APP_ERROR = 'Cannot detect miniApp type.';
export var NOT_IMPLEMENT_ERROR = 'This method/app has not been implemented yet.';
export var DEVICE_ID_STORAGE_KEY = 'RANGERS_MINI_SDK_DEVICE_ID';
export var RANGERS_PAGE_SESSION_ID = 'RANGERS_PAGE_SESSION_ID';
export var RANGERS_PAGE_TIMING = 'RANGERS_PAGE_TIMING';
//# sourceMappingURL=constants.js.map